import { FieldRenderProps } from "react-final-form";
import React from "react";
import { Theme, Tooltip } from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/styles";

const truncString = (str: string, numberOfVisibleSigns: number) => {
  return str.length > numberOfVisibleSigns
    ? str.substr(0, numberOfVisibleSigns - 1) + " ..."
    : str;
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    tooltip: {
      whiteSpace: "pre-wrap",
      wordBreak: "keep-all",
      fontSize: 13
    },
    field: {
      wordBreak: "break-word"
    }
  })
);

export const DefaultPresentationComponent = (props: FieldRenderProps<any>) => {
  let input = props.input.value;
  const numberOfVisibleSigns = 120;
  const classes = useStyles();

  if (input && Array.isArray(input)) {
    input = input.join(", ");
  }
  const resultString = "" + input !== undefined ? input : "";

  if (resultString.length > numberOfVisibleSigns) {
    return (
      <Tooltip title={<pre className={classes.tooltip}>{resultString}</pre>}>
        <div className={classes.field}>
          {truncString(resultString, numberOfVisibleSigns)}
        </div>
      </Tooltip>
    );
  } else {
    return <div className={classes.field}>{resultString}</div>;
  }
};
